"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricMapZoomControl = exports.FabricMapZoomControlPure = void 0;
const gds_ux_components_1 = require("@granular/gds-ux-components");
const react_1 = __importDefault(require("react"));
const map_1 = require("../map");
const react_intl_1 = require("react-intl");
const FabricMapZoomControlPure = ({ map, }) => {
    /**
     * If inside a FabricMapHost, this locks the resetBounds button to those passed into FabricMapHost
     */
    const { fitBounds: contextFitBounds, fitBoundsOptions } = react_1.default.useContext(map_1.FabricMapFitBoundsContext);
    /**
     * Preferred Order for Bounds:
     * - Context
     * - Props
     * - Default
     */
    const fitBounds = react_1.default.useMemo(() => contextFitBounds || map.getBounds(), [contextFitBounds, map]);
    return (react_1.default.createElement(gds_ux_components_1.GKPosition, { position: gds_ux_components_1.Position.BR, style: 
        /* This puts the zoom controls above the pins */
        { zIndex: 4 } },
        react_1.default.createElement(gds_ux_components_1.GKToolbar, { orientation: gds_ux_components_1.Orientation.Vertical, className: "bg-dark", actions: [
                {
                    icon: gds_ux_components_1.GKIconName.FilterCenterFocus,
                    tooltip: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "Reset_map_orientation" }),
                    onClick: () => map.fitBounds(fitBounds, fitBoundsOptions),
                    id: "resetBounds",
                    "data-qa": "zoom-control-reset",
                },
                {
                    icon: gds_ux_components_1.GKIconName.Add,
                    onClick: () => map.zoomIn(),
                    id: "zoomIn",
                    "data-qa": "zoom-control-zoom-in",
                },
                {
                    icon: gds_ux_components_1.GKIconName.Remove,
                    onClick: () => map.zoomOut(),
                    id: "zoomOut",
                    "data-qa": "zoom-control-zoom-out",
                },
            ] })));
};
exports.FabricMapZoomControlPure = FabricMapZoomControlPure;
/**
 * **This component must be included inside a FabricMap or FabricMapHost**.
 *
 * Renders the re-center, zoom in, and zoom out buttons.
 *
 * If there are FitBounds options passed to the parent component,
 * the zoom control will use those to determine the bounds for the recenter map button.
 * Otherwise, the zoom controls will reset to the initial map bounds on load.
 */
exports.FabricMapZoomControl = (0, map_1.withMap)(exports.FabricMapZoomControlPure);
